// extracted by mini-css-extract-plugin
export default {"root":"profileDetails_root__6RNDM","content":"profileDetails_content__pKiUr","tabContent":"profileDetails_tabContent__zBhBp"};